import React, { useEffect, useState } from "react";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import SelectSearch from "react-select-search";
import { useCommonApi } from "src/_common/hooks/actions/commonApiCall/appCommonApiCallHook";

const StatesSelect = ({ selectedStateId, setSelectedStateId, selectedCountryId, className, setType }: any) => {
  const commonApi = useCommonApi();
  const toast = useToaster();

  const [stateList, setStateList] = useState<any>();
  const [showState, setShowState] = useState<boolean>(false);

  const getStates = (countryId: any, type: any = 1) => {
    // console.log({ countryId });
    // setSelectedCountryId(countryId);
    setShowState(false);
    let params = { countryId, type };
    commonApi.callGetStates(
      params,
      (message: string, resp: any) => {
        // console.log(resp);
        // setStateList(resp);
        if (resp && resp.length > 0) {
          let x: any = [];
          resp.map((v: any, i: any) => {
            let myObj = {
              name: v.state_name,
              value: v.id.toString(),
            };
            x.push(myObj);
          });
          setStateList(x);
          // console.log({ x });
          setSelectedStateId(null);

          setTimeout(() => {
            setShowState(true);
          }, 500);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    if (selectedCountryId) {
      getStates(selectedCountryId, setType);
    }
  }, [selectedCountryId, setType]);

  // useEffect(() => {
  //   console.log({ stateList });
  // }, [stateList]);

  return (
    <React.Fragment>
      {stateList && stateList.length > 0 && showState ? (
        <SelectSearch
          value={selectedStateId + ""}
          options={stateList}
          onChange={(e) => setSelectedStateId(e)}
          onBlur={() => {}}
          onFocus={() => {}}
          placeholder="Select State"
          search
          autoComplete="off"
        />
      ) : (
        <select className={className} disabled>
          <option value="">-- Select State --</option>
        </select>
      )}
    </React.Fragment>
  );
};
export default StatesSelect;
